import { Directive, ElementRef, HostListener, inject, output } from '@angular/core';

/**
 * This directive can be set on a html tag to check click outside of the tag.
 */
@Directive({
  selector: '[ishClickOutside]',
})
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef);

  /**
   * Event to tell the listener, when there was an outside click
   */
  readonly isClickedOutside = output<boolean>();

  /**
   * Method to check click outside of the targetElement. Emits true, when a click outside was checked.
   */
  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: ElementRef): void {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.isClickedOutside.emit(true);
    }
  }
}
